<template>
  <v-list-item-subtitle>
    <slot />
  </v-list-item-subtitle>
</template>

<script>
export default {
  props: {},
};
</script>
